<template>
	<el-table :data="tableData" border style="width: 100%">
		<el-table-column
			label="序号"
			align="center"
			width="50"
			type="index"
		></el-table-column>
		<el-table-column
			v-for="(item, index) in state.columnConfig[source]"
			:key="index"
			:label="item.label"
			:prop="item.prop"
			align="center"
		></el-table-column>
	</el-table>
</template>

<script>
import { reactive } from "@vue/reactivity";
export default {
	props: {
		tableData: {
			type: Array,
			default() {
				return [];
			},
		},
		source: {
			type: Number,
			default: 0,
		},
	},
	setup() {
		const state = reactive({
			columnConfig: {
				0: [
					{
						label: "订单号",
						prop: "orderId",
					},
					{
						label: "订单时间",
						prop: "orderTime",
					},
					{
						label: "订单总金额",
						prop: "price",
					},
					{
						label: "平台收益",
						prop: "pamount",
					},
					{
						label: "洗手收益",
						prop: "xamount",
					},
					{
						label: "业主收益",
						prop: "yamount",
					},
				],
				4: [
					{
						label: "订单号",
						prop: "orderId",
					},
					{
						label: "订单时间",
						prop: "orderTime",
					},
					{
						label: "订单总金额",
						prop: "amount",
					},
				],
				1: [
					{
						label: "姓名",
						prop: "userName",
					},
					{
						label: "手机号",
						prop: "userPhone",
					},
					{
						label: "订单号",
						prop: "orderId",
					},
					{
						label: "时间",
						prop: "orderTime",
					},
					{
						label: "收益",
						prop: "amount",
					},
				],
				2: [
					{
						label: "姓名",
						prop: "userName",
					},
					{
						label: "手机号",
						prop: "userPhone",
					},
					{
						label: "订单号",
						prop: "orderId",
					},
					{
						label: "时间",
						prop: "orderTime",
					},
					{
						label: "收益",
						prop: "amount",
					},
				],
			},
		});

		return {
			state,
		};
	},
};
</script>

<style scoped>
</style>
